function RefreshButton({ onClick, loadingData }) {
  return (
    <>
      <button
        className=" btn bg-danger-subtle text-danger rounded-circle"
        aria-label="Refresh"
        onClick={() => {
          onClick();
        }}
        disabled={loadingData}
      >
        {loadingData ? (
          <>
            {" "}
            <span
              className="spinner-border spinner-border-sm"
              aria-hidden="true"
            ></span>
            <span className="visually-hidden" role="status">
              Loading...
            </span>
          </>
        ) : (
          <i className="bi bi-arrow-clockwise"></i>
        )}
      </button>
    </>
  );
}

export default RefreshButton;
